import { Component, OnInit, ViewChild } from '@angular/core';
import { DbContextService } from 'src/app/services/db-context.service';
import { MainService } from 'src/app/services/main.service';
import { DialogComponent } from '../dialog/dialog.component';
import { DialogService } from '../dialog/dialog.service';

export interface PopUpModel {
  title: string;
}

@Component({
  selector: 'app-item-search',
  templateUrl: './item-search.component.html',
  styleUrls: ['./item-search.component.css']
})
export class ItemSearchComponent extends DialogComponent<PopUpModel, boolean>
  implements PopUpModel, OnInit {

  title: string;
  result: any = { result: false, RtnItem: {} };
  cols: any;
  data: any;
  selected_row: any;
  selected_index = 0;
  totalCount = 0;
  loading = false;
  @ViewChild('dt') dt: any;
  filterModel: any = {
    Barcode: '',
    Name: '',
    SellingPrice: '',
    SupplierName: '',
    RefNo: ''
  };

  constructor(public dialogService: DialogService, private db: DbContextService, private ms: MainService) {
    super(dialogService);
  }

  ngOnInit() {
    this.cols = [
      { field: 'Barcode', header: 'Barcode', f: 'text' },
      { field: 'RefNo', header: 'Item Code', f: 'text' },
      { field: 'Name', header: 'Name', f: 'text' },
      { field: 'SellingPrice', header: 'Rate', f: 'decimal' },
    ];

    if (this.ms.CommonSetting.ShowCostPriceOnItemSearch) {
      this.cols.push({ field: 'CostPrice', header: 'Cost', f: 'decimal' });
    }

    this.loadItems();
  }

  loadItems(start = 0) {
    const data = {
      SellingPricelevel: this.ms.getSettings().SellingPriceLevelId,
      Branch: this.ms.getSettings().BranchId,
      Location: this.ms.getSettings().LocId,
      RequestedList: {
        Start: start,
        FiterText: '',
        Limit: 14,
        ItemTypeId: 1,
        CAType: 1
      },
      FilterData: {
        Name: this.filterModel.Name,
        Barcode: this.filterModel.Barcode,
        RefNo: this.filterModel.RefNo,
        CostPrice: 0,
        SellingPrice: this.filterModel.SellingPrice,
        SupplierName: this.filterModel.SupplierName,
        Dept: '',
        Cat: '',
        SubCat: '',
        Unit: ''
      }
    };
    this.loading = true;
    this.db.Get_ItemSearch(data).subscribe(res => {
      if (res.Success) {
        this.totalCount = res.total;
        this.data = res.data;
        if (start == 0) {
          document.getElementById('fil_bar_code').focus();
        }
        this.loading = false;
      }
    });
  }

  onLazyLoad(e) {
    this.loadItems(e.first);
  }

  getStyle(e) {
    let str = 'unset';
    switch (e.field) {
      case 'Barcode':
        str = '20%';
        break;
      case 'SellingPrice':
        str = '10%';
        break;
      case 'RefNo':
        str = '20%';
        break;
      case 'CostPrice':
        str = '10%';
        break;
    }
    return str;
  }

  click() {
    this.filterModel.Barcode = '123';
    this.FilterKeyDown('', 'Barcode');
  }

  FilterKeyDown(e, filed) {
    if (e.keyCode == 13) {
      this.loadItems();
    } else if (e.keyCode == 40) {
      if (this.data.length != 0) {
        this.selected_row = this.data[0];
        this.selected_index = 0;
        document.getElementById('type').focus();
      }
    }
  }

  onRowSelect(e) {
    this.selected_index = e.index;
    this.selected_row = e.data;
    document.getElementById('type').focus();
  }

  onRowDblClick(e, data, ix) {
    this.selected_index = ix;
    this.selected_row = data;
    this.Success_Close();
  }

  keyevent(e) {
    if (e.keyCode == 40) {
      let a = 13;
      if (this.data.length < 14) {
        a = this.data.length - 1;
      }
      if (this.selected_index < a) {
        this.selected_index++;
      } else {

      }
      this.selected_row = this.data[this.selected_index];
    } else if (e.keyCode == 38) {
      if (this.selected_index > 0) {
        this.selected_index--;
      }
      this.selected_row = this.data[this.selected_index];
    } else if (e.keyCode == 13) {
      this.Success_Close();
    }
  }

  Success_Close() {
    this.result.result = true;
    this.result.RtnItem = this.selected_row;
    this.close();
  }

}
